import { COMPOSE_ONLY_FLUID_KEEP_BODY, FLUID_CHANGE_SOURCE, FLUID_ENTITY_TYPE } from '../constants';
import { OWA_INSERT_LINK_PLACEHOLDER_CLASSNAME } from 'owa-attachment-link-common';
import * as trace from 'owa-trace';
import { insertEntity } from 'roosterjs-editor-api';
import { Position } from 'roosterjs-editor-dom';
import { ContentPosition, IEditor, PositionType } from 'roosterjs-editor-types';

export function createFluidTargetAndHeader(
    editor: IEditor | undefined,
    containerDiv: HTMLDivElement | undefined,
    originalNode: Node,
    containerId?: string
): [HTMLDivElement, HTMLDivElement] {
    if (!editor && !containerDiv) {
        trace.errorThatWillCauseAlert(
            'Either containerDiv or Editor must be provided for fluid component'
        );
        throw new Error('containerDiv or Editor must be defined for fluid comp[onent to load');
    }
    const document = containerDiv ? containerDiv.ownerDocument : editor!.getDocument();
    const targetDiv =
        containerDiv ?? createEditorTargetDiv(document, editor!, originalNode, containerId);
    const headerNode = createHeaderNode(document, originalNode);
    return [targetDiv, headerNode];
}

function createEditorTargetDiv(
    document: Document,
    editor: IEditor,
    originalNode: Node,
    containerId?: string
): HTMLDivElement {
    const targetDiv = document.createElement('div');
    targetDiv.setAttribute('data-fluid-container', 'true');
    targetDiv.setAttribute('contenteditable', 'false');
    if (containerId) {
        targetDiv.className = OWA_INSERT_LINK_PLACEHOLDER_CLASSNAME;
        targetDiv.id = containerId;
    }

    const range = document.createRange();
    range.selectNode(originalNode);
    range.collapse();
    editor.insertNode(targetDiv, {
        position: ContentPosition.Range,
        range,
        updateCursor: false,
    });

    const spaceNode = document.createTextNode('');
    targetDiv.parentNode?.insertBefore(spaceNode, targetDiv);

    // Because we just inserted targetDiv into the editor this looks like it should always return true,
    // but it doesn't, and is needed because of this.
    if (editor.contains(targetDiv)) {
        const spaceNode = document.createTextNode('');
        editor.select(targetDiv, PositionType.Before);
        editor.insertNode(spaceNode);
    }

    editor.addUndoSnapshot(() => {
        insertEntity(
            editor,
            FLUID_ENTITY_TYPE,
            targetDiv,
            true /*isBlock*/,
            true /* isReadOnly */,
            new Position(targetDiv, PositionType.End)
        );
    }, FLUID_CHANGE_SOURCE);

    return targetDiv;
}

function createHeaderNode(document: Document, originalNode: Node): HTMLDivElement {
    // We mark the original node to note remove it when we clean up the component on send.
    // The header content is set as a child of another node to avoid jumpiness while loading,
    // otherwise it flashes outside of the Ux, then jumps inside of it.
    const headerNode = document.createElement('div');
    headerNode.style.overflow = 'hidden';
    headerNode.style.textOverflow = 'ellipsis';
    headerNode.style.padding = '2px';
    headerNode.appendChild(originalNode);
    headerNode.className = COMPOSE_ONLY_FLUID_KEEP_BODY;
    return headerNode;
}
